import { Badge } from '@material-ui/core';
import React, { CSSProperties, FC } from 'react';
import { AlertNotificationDto } from '../../api/apiDtos';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';

const badgeStyles: CSSProperties = {
  cursor: 'pointer',
};

interface Props {
  onClick?: (event: React.MouseEvent<any>) => void;
  alertNotifications: AlertNotificationDto[];
}

export const NotificationBell: FC<Props> = ({
  onClick,
  alertNotifications,
}) => {
  const unread = alertNotifications.filter((x) => !x.isRead);

  const noNotifications = unread.length === 0;

  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        padding: '6px 14px',
        borderRadius: 6,
        fontSize: 13,
        fontWeight: 500,
        color: 'var(--color-text-secondary)',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--color-muted-bg)';
        e.currentTarget.style.color = 'var(--color-text-primary)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
        e.currentTarget.style.color = 'var(--color-text-secondary)';
      }}
    >
      <Badge
        overlap="rectangular"
        style={badgeStyles}
        badgeContent={unread.length}
        color="secondary"
        invisible={noNotifications}
      >
        <NotificationsIcon style={{ fontSize: 16 }} />
      </Badge>
      Alerts
    </div>
  );
};
